import { render } from "./EmployeeUpload.vue?vue&type=template&id=3623d56a&scoped=true&ts=true"
import script from "./EmployeeUpload.vue?vue&type=script&lang=ts"
export * from "./EmployeeUpload.vue?vue&type=script&lang=ts"

import "./EmployeeUpload.vue?vue&type=style&index=0&id=3623d56a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3623d56a"]])

export default __exports__